import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vbit_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (typeof window !== "undefined" && !window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function verifyToken() {
  try {
    const { data } = await api.get("/me");
    return !!data?.success;
  } catch {
    return false;
  }
}

export async function login(username, password) {
  const { data } = await api.post("/login", { username, password });
  return data;
}

export async function fetchConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function transcribeAudio(file) {
  const form = new FormData();
  form.append("audio", file);
  const { data } = await api.post("/transcribe", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function uploadAttachment(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload-attachment", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function generateBugReport(transcription, attachmentType) {
  const { data } = await api.post("/generate-bug-report", {
    transcription,
    attachment_type: attachmentType || null,
  });
  return data;
}

export async function submitBug(bug, attachmentFilename) {
  const { data } = await api.post("/submit-bug", {
    bug,
    attachment_filename: attachmentFilename || null,
  });
  return data;
}
